/** Same output as Orion's `truncateMiddle` i18n formatter. */
export function truncateMiddle(value: string, left = 5, right = 4): string {
  if (value.length <= left + right) {
    return value;
  }
  return `${value.slice(0, left)}...${value.slice(-right)}`;
}
